import React from 'react';

import * as S from './styles';

const Gallery03: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Photo1
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="200ms"
        />
        <S.Caption className="mobile">
          <p>
            Look do verão de 2023 de Thom Browne feito em tweed, um dos
            principais tecidos da coleção. | Foto: Getty Images
          </p>
        </S.Caption>
        <S.PhotoWrapper>
          <S.Photo2
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          />
          <S.Caption className="desktop">
            <p>
              À esq., detalhe da união de grafismos xadrez em look do verão 2023
              de Thom Browne; à dir., uniformes listrados (Getty Images); looks
              esportivos listrados da Household Brigade, grupo de militares
              britânicos durante a Primeira Guerra Mundial, nos anos 1910
              (reprodução do livro “100 anos de moda masculina”).
            </p>
          </S.Caption>
        </S.PhotoWrapper>
        <S.Caption className="mobile">
          <p>
            Detalhe da união de grafismos xadrez em look do verão 2023 de Thom
            Browne. | Foto: Getty Images
          </p>
        </S.Caption>
      </S.Wrapper>
    </S.Container>
  );
};

export default Gallery03;
